import React from "react";
import {EvacuadosPorSector as EvacuadosPorSectorContainer} from '../../../containers/EvacuadosPorSector'
import { CAMPAIGN_2024 } from '../../../constants';

const EvacuadosPorSector = () => {
  return <EvacuadosPorSectorContainer campaign={CAMPAIGN_2024} year={2024}/>
};

export default EvacuadosPorSector;
